import { companyDao } from '@/service';

export default {
  state: {},
  mutations: {},
  actions: {   
    getAllCompanies(){
      const config = {
        params: {
          perPage: 20,       
        },
      };
      return new Promise((resolve, reject) => {
        companyDao
          .getAllCompanies(config)
          .getPage()
          .then((resp) => {
            resolve(resp.data.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createCompany(_, payload) {
      return new Promise((resolve, reject) => {
        companyDao
          .createCompany(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCompany(_, payload) {
      return new Promise((resolve, reject) => {
        companyDao
          .getCompany(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAllClients() {
      return new Promise((resolve, reject) => {
        companyDao
          .getAllClients()
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },   
    updateCompany(_, payload) {
      return new Promise((resolve, reject) => {
        companyDao
          .updateCompany(payload)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  getters: {},
};
